import { useQuery } from '@tanstack/react-query'
import { requestLoyaltyPlanListStatment, getLoyaltyPlansForStatement } from '../../api/statementAccount'
import { QUERY_KEYS } from '../../constants/queryKeys'

function useGetLoyaltyPlansForStatement(request:requestLoyaltyPlanListStatment) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_LOYALTY_PLANS_ACCOUNT_STATEMENT_LIST],
      queryFn: () => getLoyaltyPlansForStatement(request),
   })
}

export { useGetLoyaltyPlansForStatement }
export default useGetLoyaltyPlansForStatement